import { GroupType } from "src/types/ZGroup";
import * as React from "react";
import { CommonNodeO2, GroupO2 } from "../Obj2Nodes";

const isMnemonicGroup = (node: CommonNodeO2): node is GroupO2 =>
  node.type === "group" && node.group.groupType.name === GroupType.Mnemonic;

export const findNodeOwnerMnemonicGroup = (
  key: React.Key,
  nodes: CommonNodeO2[],
): GroupO2 | undefined => {
  // eslint-disable-next-line no-restricted-syntax
  for (const node of nodes) {
    const childNode = node.children?.find((n) => n.key === key);
    if (childNode && isMnemonicGroup(node)) {
      return node;
    }
    if (node.children) {
      const subNode = findNodeOwnerMnemonicGroup(key, node.children);
      if (subNode) {
        return subNode;
      }
    }
  }
  return undefined;
};
